import styles from "@css/modules/Resort.module.scss"
import { Carousel } from "../../Animation/Carousel"
import { ArrowLeftThin } from "@css/icons/SVG"
import React from "react"
import { SlideAppear } from "../../Animation/SlideAppear"
import { Image } from "@t/Image"
import NextImage from "next/image"

export function ResortCarousel({ items }: { items: Image[] }) {
    const prevBtn = (click: () => void) => (
        <button onClick={click} className={styles.prevBtn} aria-label="go prev">
            <ArrowLeftThin />
        </button>
    )
    const nextBtn = (click: () => void) => (
        <button onClick={click} className={styles.nextBtn} aria-label="go next">
            <ArrowLeftThin />
        </button>
    )
    let maxHeight = 0
    let first
    items.forEach((item) => {
        const format = item.formats.medium || item.formats.thumbnail
        if (maxHeight < format.height) {
            maxHeight = format.height
            first = item
        }
    })
    const firstFormat = first?.formats?.medium || first?.formats?.thumbnail

    return (
        <SlideAppear className={styles.galleryRoot} style={{ "--maxHeight": `${maxHeight}px` }}>
            <Carousel
                heightProvider={
                    first && (
                        <NextImage
                            unoptimized={true}
                            loading="lazy"
                            className={styles.carouselImage}
                            alt={first.alternativeText}
                            height={firstFormat.height}
                            src={firstFormat.url}
                            width={firstFormat.width}
                        />
                    )
                }
                startAt={0}
                autoplayTime={0}
                classNames={{
                    itemActive: styles.itemActive,
                    item: styles.item,
                    itemNext: styles.itemNext,
                    itemPrev: styles.itemPrev,
                    root: styles.carousel
                }}
                prevBtn={prevBtn}
                nextBtn={nextBtn}
                items={items.map((i, key) => {
                    const format = i.formats.medium || i.formats.thumbnail
                    return (
                        <NextImage
                            unoptimized={true}
                            loading="lazy"
                            key={key}
                            className={styles.carouselImage}
                            alt={i.alternativeText}
                            height={format.height}
                            src={format.url}
                            width={format.width}
                        />
                    )
                })}
            />
        </SlideAppear>
    )
}
